import React from 'react'
import Button from '../../../../designSystem/Buttons/Index'

const KnowMoreSection = () => {
  return (
    <div className='tl-know-more-section' data-aos="fade-up">
        <h1>¿Quieres saber más?</h1>
        <p>Contáctanos para agendar una demo, uno de nuestros agentes se comunicará contigo a la brevedad. Comienza a entregar un soporte continuo y real a tus empleados, para que reciban ayuda cuando más lo necesiten.</p>
        <div className="buttons-container">
            <Button 
                type='fill'
                color='accent'
                text='Agenda una demo'
                onClickHandler={() => window.location.href = `/${document.body.dataset.site}/empresas#contact-section`}
            />
        </div>
    </div>
  )
}

export default KnowMoreSection